import React from 'react';
import { VehiclesFieldArray } from 'components/shared/VehiclesFieldArray';
import { VehiclesFieldArrayOutlined } from 'components/shared/VehiclesFieldArrayOutlined';

import { FieldArray } from 'redux-form';

class Vehicles extends React.Component {
  render() {
    return (
      <div className="row">
        <FieldArray
          name="vehicle_information"
          component={this.props.outlined ? VehiclesFieldArrayOutlined : VehiclesFieldArray}
        />
      </div>
    );
  }
}

export default Vehicles;
